module.exports = __webpack_public_path__ + "img/campaign-cashback.02e50933.svg";